export default "__VITE_ASSET__RjloneKn__"